var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37259 0 0 5.3428 0 11.9335C0 18.5242 5.37259 23.867 12 23.867C18.6274 23.867 24 18.5242 24 11.9335C23.993 5.34575 18.6245 0.00704223 12 0ZM12 22.1622C6.31934 22.1622 1.71427 17.5826 1.71427 11.9335C1.71427 6.28431 6.31934 1.70477 12 1.70477C17.6807 1.70477 22.2857 6.28431 22.2857 11.9335C22.2796 17.5801 17.6781 22.1561 12 22.1622Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71427 12.4285C8.66104 12.4285 9.42854 11.661 9.42854 10.7143C9.42854 9.76751 8.66104 9 7.71427 9C6.76751 9 6 9.76751 6 10.7143C6 11.661 6.76751 12.4285 7.71427 12.4285Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 12.4285C17.2323 12.4285 17.9998 11.661 17.9998 10.7143C17.9998 9.76751 17.2323 9 16.2856 9C15.3388 9 14.5713 9.76751 14.5713 10.7143C14.5713 11.661 15.3388 12.4285 16.2856 12.4285Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2822 15.325C14.9991 14.9456 14.462 14.8676 14.0826 15.1507C14.0662 15.163 14.0503 15.1758 14.0348 15.1892C12.8226 16.0746 11.1772 16.0746 9.96501 15.1892C9.60687 14.8796 9.06556 14.9191 8.75604 15.2772C8.44646 15.6353 8.48589 16.1767 8.84403 16.4862C8.8595 16.4996 8.87547 16.5124 8.89189 16.5247C10.7266 17.927 13.2732 17.927 15.1079 16.5247C15.4873 16.2415 15.5654 15.7044 15.2822 15.325Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.8cf3a2e1ccdfed5416d92042dc6063ae.svg";
export { ForwardRef as ReactComponent };